import styled from "styled-components";

import line from "../../images/line.svg";

export const BlackBoxWrapper = styled.div`
  max-width: 1088px;
  min-height: 208px;
  margin: 0 auto 140px;
  padding: 56px 80px;
  color: #fff;
  background-color: var(--black);
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    margin: 0 24px 64px;
    padding: 32px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const H2 = styled.h2`
  font-size: 36px;
  margin-right: 32px;
  max-width: 600px;
  font-weight: 800;

  span {
    position: relative;
  }

  span::after {
    content: "";
    width: 100%;
    height: 10px;
    position: absolute;
    left: 0;
    bottom: -6px;
    background-image: url(${line});
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

export const Text = styled.p`
  max-width: 368px;
  margin-top: 24px;
  line-height: 28px;
`;

export const TextTesteGratis = styled(Text)`
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;
